export default __webpack_public_path__ + "static/media/advance2.6ae4eeb0.png";